import { useEditorAccess } from 'flow/editor/context';
import { getIsEditable } from 'flow/service/general';
import { StyledGrayText, StyledTextField } from './styles';

type AxisHeaderTextInputProps = {
  autoComplete: 'on' | 'off';
  type: string;
  placeholder: string;
  value: string | number;
  id: string;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  onBlur: React.FocusEventHandler<HTMLInputElement>;
  onKeyDown: React.KeyboardEventHandler<HTMLInputElement>;
  readOnly?: boolean;
};

export const AxisHeaderTextInput = ({
  autoComplete,
  type,
  placeholder,
  value,
  id,
  onChange,
  onBlur,
  onKeyDown,
  readOnly,
}: AxisHeaderTextInputProps) => {
  const { editorMode } = useEditorAccess();
  const inEditMode = !readOnly && getIsEditable(editorMode);
  return inEditMode ? (
    <StyledTextField
      autoComplete={autoComplete}
      type={type}
      placeholder={placeholder}
      value={value}
      id={id}
      onChange={onChange}
      onBlur={onBlur}
      onKeyDown={onKeyDown}
    />
  ) : (
    <StyledGrayText>
      {value}
    </StyledGrayText>
  );
};
